import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {storeMap} from '@/plugins/piniaStoreById';
import {computed} from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
  module: {
    type: String,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const store = storeMap.get(props.module);

const page = computed({
  get(): number {
    if (!store) return 0;
    return store.page + 1;
  },
  async set(newPage: number) {
    if (!store) return;
    store.page = newPage - 1;
  },
});
const pageCount = computed((): number => {
  if (!store) return 0;
  return store.pageCount;
});

__expose({
  page,
  pageCount,
});

return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createBlock(_component_v_pagination, {
    modelValue: page.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
    length: pageCount.value
  }, null, 8, ["modelValue", "length"]))
}
}

})